import { messages as messagesEN } from './en';

export const messages: typeof messagesEN = {
  HOME: { TITLE: 'Startseite', ROUTE: '/home' },
  ABOUT: { TITLE: 'Über die Anwendung', ROUTE: '/about' },
  DEFINE_BOX: { TITLE: 'Morphologischer Kasten', ROUTE: '/define' },
  SETTINGS: { TITLE: 'Einstellungen', ROUTE: '/settings' },
  CREATE_SCENARIO: { TITLE: 'Szenario erstellen', ROUTE: '/create' },
  SHOW_SCENARIO: { TITLE: 'Szenarien anzeigen', ROUTE: '/show' },
  DECISION_SUPPORT: { TITLE: 'Entscheidungsunterstützung', ROUTE: '/decide' },
  DOWNLOAD: {
    COLLECTION: 'Sammlung speichern',
    MODEL: 'Box-Datei speichern',
  },
  DOWNLOAD_FILENAME_TITLE: 'Box-Datei speichern',
  DOWNLOAD_FILENAME_LABEL: 'Dateiname',
  UPLOAD: {
    COLLECTION: 'Sammlung laden',
    MODEL: 'Box-Datei laden',
  },
  OPEN_MENU: 'Menü öffnen',
  UPLOAD_FILE: 'Box oder Sammlung laden',
  IMPORT_READ_ERROR: 'Die ausgewählte Datei konnte nicht gelesen werden.',
  COLLECTION_LOAD_FAILED: 'Die Sammlung konnte nicht geladen werden. Prüfen Sie Ihre Verbindung und laden Sie die Seite neu.',
  STARTER_KIT_LOAD_FAILED: 'Das Starterpaket konnte nicht geladen werden. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.',
  IMPORT_COLLECTION_TITLE: 'Sammlung ersetzen?',
  IMPORT_COLLECTION_MSG:
    'Diese Datei enthält eine Sammlung. Beim Laden wird Ihre aktuelle Sammlung einschließlich nicht gespeicherter Änderungen ersetzt. Fortfahren?',
  CANCEL: 'Abbrechen',
  DELETE: 'Löschen',
  AND: 'und',
  YES: 'Ja',
  NO: 'Nein',
  OK: 'Ok',
  NAME: 'Name',
  DESCRIPTION: 'Beschreibung',
  NEW_BOX: 'Neuer morphologischer Kasten',
  CATEGORIES: 'Kategorien',
  DIMENSION: 'Schlüsseltreiber',
  DIMENSION_SELECTED: 'Ausgewählte Treiber',
  DIMENSIONS: 'Treiber',
  KEY_VALUE: 'Schlüsselwert',
  OPTION_USAGE_LEGEND: 'Verwendung der Optionen in einbezogenen Szenarien',
  OPTION_USAGE_RANGE: '{range}-mal in einbezogenen Szenarien verwendet',
  OPTION_USAGE_COUNT: '{count}x verwendet',
  CONTEXT: 'Kontext',
  NONE: 'Keine',
  LOCATION: 'Standort',
  LOCATION_TYPE: 'Standorttyp',
  COORDINATES: 'Koordinaten',
  LOCATION_NAME: 'Standortname',
  LATITUDE: 'Breitengrad',
  LONGITUDE: 'Längengrad',
  MANUAL: 'Manueller Modus',
  Type: 'Typ',
  PICK_FROM_LIST: 'Aus Liste wählen',
  ENTER_KEY_VALUE: 'Schlüsselwert eingeben',
  EDIT_COMPONENT: 'Komponente bearbeiten',
  ADD_COMPONENT: 'Komponente hinzufügen',
  GENERATE_NARRATIVE: 'Generieren',
  CLEAR_NARRATIVE: 'Löschen',
  NAME_NARRATIVE: 'Titel des aktuellen Szenarios',
  SAVE_NARRATIVE: 'Speichern',
  SAVED_NARRATIVES: 'Gespeicherte Szenarien',
  HOME_WORK_TITLE: "Szenariotyp wählen",
  HOME_WORK_HINT: "Beginnen Sie mit einem fertigen Szenariotyp aus dem Starterkit und erstellen und vergleichen Sie damit Ihre Szenarien.",
  HOME_OPTIONS_TITLE: "Anpassen oder selbst erstellen",
  HOME_EDIT_CARD_TITLE: "Szenariotyp anpassen",
  HOME_EDIT_CARD_DESC: "Fügen Sie Faktoren und Optionen hinzu, ändern oder entfernen Sie sie, damit der gewählte Typ zu Ihrer Situation passt.",
  HOME_AI_CARD_TITLE: "Neuen Szenariotyp erstellen",
  HOME_AI_CARD_DESC: "Lassen Sie KI eine morphologische Box für Ihr Thema vorschlagen, oder beginnen Sie selbst mit einer leeren Box.",
  HOME_MAP_CARD_TITLE: "Szenarien auf der Karte",
  HOME_MAP_CARD_DESC: "Spielt Ihr Szenario an erkennbaren Orten, etwa einem Kernkraftwerk oder einem Denkmal? Schalten Sie die Karte ein, öffnen Sie Box bearbeiten und fügen Sie über den Stift einer Option Koordinaten oder einen Ortstyp hinzu. Diese Orte erscheinen dann auf der Karte Ihrer Szenarien.",
  HOME_MAP_CARD_ENABLE: "Karte einschalten",
  HOME_MAP_CARD_ENABLED: "Die Karte ist eingeschaltet. Fügen Sie Optionen über Box bearbeiten Orte hinzu.",
  TUTORIAL_CARD_TITLE: "Tutorial",
  TUTORIAL_CARD_DESC: "Sehen Sie, wie Sie mit einem KI-Assistenten in einem Schritt ein vollständiges Szenario erstellen: Erzählung, Reflexionen zu Handlungsoptionen und Persona-Feedback.",
  TUTORIAL_WATCH: "Tutorial ansehen",
  TUTORIAL_TITLE: "Tutorial: ein vollständiges Szenario mit KI",
  TUTORIAL_DESC: "Vom Starterkit zur Entscheidung: Szenario generieren, einen KI-Assistenten Erzählung, Reflexionen und Persona-Feedback als JSON schreiben lassen, einfügen und die Ergebnisse analysieren.",
  TUTORIAL_NARRATION: "Sprache der Erzählung",
  HOME_MAP_CARD_ACTIVE: "Die Karte ist für diesen Szenariotyp eingeschaltet.",
  HOME_MAP_CARD_LOCATIONS: "Orte hinzufügen",
  DECISION_BANNER_MSG: "Dieser Szenariotyp enthält Maßnahmen für die Entscheidungsunterstützung. Schalten Sie sie ein, um Maßnahmen zu wählen, Handlungsoptionen zu vergleichen und Entscheidungen festzuhalten.",
  DECISION_HELP_TITLE: "Wie funktioniert die Entscheidungsunterstützung?",
  DECISION_HELP_STEP1: "Beschreiben Sie unter Szenario erstellen die Lage: Wählen Sie die Faktoren des Vorfalls und speichern Sie das Szenario.",
  DECISION_HELP_STEP2: "Wählen Sie unter Entscheidungen die Maßnahmen, die zur Lage passen. Jede Gruppe von Maßnahmen ist eine Handlungsoption; erstellen Sie mehrere, um Alternativen zu vergleichen.",
  DECISION_HELP_STEP3: "Schätzen Sie für jede Handlungsoption die verbleibende Wahrscheinlichkeit und Auswirkung ein.",
  DECISION_HELP_STEP4: "Vergleichen Sie die Handlungsoptionen hier in der Übersicht, im Vergleich, in der Robustheitsansicht und in der Risikomatrix.",
  DECISION_HELP_STEP5: "Halten Sie die Entscheidung mit Begründung im Entscheidungsprotokoll fest und exportieren Sie alles nach Word.",
  PERSONA_CLIPBOARD_HINT: "Es ist kein Sprachmodell verbunden. Die Schaltfläche kopiert daher einen Prompt: Fügen Sie ihn in den Chat Ihres KI-Assistenten ein und die Antwort in das Feedbackfeld der Persona. Verbinden Sie unter Einstellungen → LLM ein Sprachmodell, um Feedback direkt zu erzeugen.",
  SETUP_LLM: "Sprachmodell einrichten",
  NARRATIVE_PROMPT_COPIED: "Geschichten-Prompt kopiert. Fügen Sie ihn in den Chat Ihres KI-Assistenten ein und die Antwort in das Geschichtenfeld.",
  EDIT_BOX: 'Box bearbeiten',
  NO_SAVED_NARRATIVES: 'Noch keine gespeicherten Szenarien in dieser Box. Erstellen Sie eines.',
  NO_MATCHING_NARRATIVES: 'Keine Szenarien entsprechen dieser Suche.',
  OPEN_SCENARIO: 'Szenario öffnen',
  COMPARE_SCENARIOS: 'Szenarien vergleichen',
  HIDE_COMPARISON: 'Vergleich ausblenden',
  BOX_ACTIONS: 'Weitere Aktionen',
  PERMALINK: 'Permalink kopieren',
  PERMALINK_COPIED: 'Permalink in die Zwischenablage kopiert. Fügen Sie ihn in eine E-Mail ein, um diese Box zu teilen.',
  PERMALINK_COPIED_LONG: 'Permalink kopiert, aber er ist sehr lang: Manche E-Mail-Programme können ihn abschneiden. Senden Sie besser die heruntergeladene Datei.',
  PERMALINK_INVALID: 'Der geteilte Link ist ungültig oder unvollständig.',
  COLLECTION_ACTIONS: 'Sammlungsverwaltung',
  LANGUAGE_NAMES: {
    nl: 'Nederlands', en: 'English', fr: 'Français',
    de: 'Deutsch', es: 'Español', pl: 'Polski',
  },
  FILTER_NARRATIVES: 'Szenarien filtern',
  FILTER_NARRATIVES_PLACEHOLDER: 'Zum Filtern nach Name eingeben...',
  NARRATIVE: 'Szenario',
  INCLUDE_NARRATIVE: "Für Analyse auswählen",
  NARRATIVE_INCLUDED: "Für Analyse ausgewählt",
  SELECT_NARRATIVE: 'Szenario auswählen',
  SELECT_SCENARIO: "Szenariotyp",
  SELECT_GROUP_OWN: "Meine Szenariotypen",
  SELECT_GROUP_STARTER: "Starterpaket",
  KEY: 'Schlüssel',
  VALUE: 'Wert',
  MODEL: 'Modell',
  SELECTION: 'Ausgewählter Wert',
  EDITOR_PLACEHOLDER: 'Szenario bearbeiten',
  THRESHOLDS: 'Schwellenwertfarben für Komponentenoptionen',
  THRESHOLD: 'Schwellenwert',
  COLOR: 'Farbe',
  ORDER: 'Reihenfolge',
  COMBINATIONS: {
    POSSIBLE: 'Kombinationen sind möglich',
    IMPOSSIBLE: 'Kombinationen sind unmöglich',
    IMPROBABLE: 'Kombinationen sind unwahrscheinlich',
  },
  DELETE_ITEM: {
    title: '{item} löschen',
    description:
      'Sind Sie sicher, dass Sie diese(s) {item} löschen möchten? Es gibt kein Zurück.',
  },
  NEW_SCENARIO: 'Neue Box',
  ADD_STARTER_KIT: 'Starterpaket hinzufügen oder aktualisieren',
  ADD_STARTER_KIT_HINT: 'Fügt fehlende Starterboxen und Personas hinzu und aktualisiert unveränderte. Bearbeitete Elemente werden erst nach Ihrer Bestätigung ersetzt.',
  STARTER_KIT_ADDED: 'Starterpaket: {added} hinzugefügt, {updated} aktualisiert.',
  STARTER_KIT_CONFLICT_TITLE: 'Bearbeitete Starterelemente überschreiben?',
  STARTER_KIT_CONFLICT_MSG: 'Sie haben diese Starterelemente geändert. Wählen Sie aus, welche durch die aktuelle Version des Starterpakets ersetzt werden sollen. Ihre Änderungen daran, einschließlich Narrative und Entscheidungen, gehen verloren. Nicht ausgewählte Elemente bleiben unverändert.',
  STARTER_KIT_SELECT_ALL: 'Alle auswählen',
  STARTER_KIT_UPDATE: 'Aktualisieren',
  STARTER_KIT_KIND_BOX: 'Box',
  STARTER_KIT_KIND_PERSONA: 'Persona',
  STARTER_KIT_ALREADY_PRESENT: 'Das Starterpaket ist bereits aktuell.',
  NEW_MODEL: {
    btn: 'Neue Sammlung',
    title: 'Neue Sammlung auswählen',
    description:
      'Ihre aktuelle Sammlung wird ersetzt. Laden Sie sie zuerst herunter, wenn Sie sie behalten möchten.',
    choose: 'Wählen Sie Ihre neue Sammlung',
  },
  DELETE_MODEL: {
    btn: 'Box löschen',
    title: 'Ausgewählte Box löschen',
    description:
      'Diese Box und ihre gespeicherten Szenarien löschen? Dies kann nicht rückgängig gemacht werden.',
  },
  INCONSISTENCIES: {
    title: 'Inkonsistenzen',
    SELECT_ROW_CATEGORY: 'Zeilenkategorie auswählen',
    SELECT_COLUMN_CATEGORY: 'Spaltenkategorie auswählen',
    SELECT_CATEGORIES_TO_START: 'Kategorien zum Starten auswählen',
    NO_DRIVERS:
      'Für diese Kategoriekombination sind keine Schlüsseltreiber mit Werten verfügbar',
    NAV_TITLE: 'Tastaturnavigation',
    NAV_ARROWS:
      'Pfeiltasten: Zwischen Zellen wechseln, mit Shift zwischen Schlüsseltreibern',
    NAV_TOGGLE: 'Leertaste oder Enter: Kombinationsstatus wechseln',
    NAV_SHIFT_VERTICAL:
      'Shift + Hoch/Runter: Aktiven Zeilen-Schlüsseltreiber wechseln',
    NAV_SHIFT_HORIZONTAL:
      'Shift + Links/Rechts: Aktiven Spalten-Schlüsseltreiber wechseln',
  },
  saveButton: {
    label: 'Speichern',
    tooltip: 'Nicht gespeicherte Änderungen speichern',
  },
  i18n: {
    /** Label for the edit button of the RepeatList */
    editRepeat: 'Bearbeiten',
    /** Label for the create button of the RepeatList */
    createRepeat: 'Hinzufügen',
    /** Label for the delete button of the RepeatList */
    deleteItem: 'Löschen',
    /** Label for the agree button of the RepeatList */
    agree: 'Ja',
    /** Label for the disagree button of the RepeatList */
    disagree: 'Nein',
    /** Pick */
    pick: 'Auswählen',
    /** Pick one */
    pickOne: 'Eines auswählen',
    /** Pick one or more */
    pickOneOrMore: 'Eines oder mehrere auswählen',
    /** Cancel button text */
    cancel: 'Abbrechen',
    /** Save button text */
    save: 'Speichern',
  },
  COMP: {
    AVAILABLEBUDGET: 'Budget',
    BEHAVIOURDURINGPREPARATION: 'Verhalten während der Vorbereitung',
    CAPABILITIES: 'Fähigkeit',
    COMPARTMENTSPRESENT: 'Vorhandene Bereiche',
    CRIMINALPHASE: 'Kriminelle Phase',
    DURATION: 'Dauer',
    EQUIPMENT: 'Ausrüstung',
    EXISTINGINFRA: 'Bestehende Infrastruktur',
    IMPACT: 'Auswirkung',
    INTENT: 'Absicht Unbeteiligter',
    LOCATION: 'Standort',
    LOCATION2: 'Standort',
    MODUSOPERANDIDURINGEXECUTION: 'Vorgehensweise',
    MOTIVATION: 'Motivation',
    NARRATIVE: 'Narrativ',
    NARRATIVE_PLACEHOLDER:
      'Beschreiben Sie den Kontext, in dem der Vorfall stattfand, z. B. eine Beschreibung des (geografischen) Standorts, der Person oder des Gebäudes, das geschützt werden muss, die Art und Weise, wie ein Akteur Informationen erhält, zu welcher Zeit die Aktion stattfand, unter welchen Wetterbedingungen, wie viele Personen an der Aktion beteiligt waren, von welcher Organisation, wie sie Zugang erhielten oder welche Mittel/Waffen eingesetzt wurden.',
    OBJECT: 'Objekt',
    OPENCOMPARTMENTS: 'Offener Bereich',
    PEOPLEDENSITY: 'Personendichte',
    PERSONS: 'Person',
    PHYSICALANGLEOFATTACKDURINGEXECUTION: 'Physischer Angriffswinkel',
    PHYSICAL_ANGLE: 'Physischer Winkel',
    PRIVACYAWARENESS: 'Datenschutzbewusstsein',
    RELATIONOWNEROBJECTANDOWNERSECURITYSYSTEM:
      'Beziehung zwischen Objekteigentümer und Eigentümer des Sicherheitssystems',
    RESPONSIBILITY: 'Verantwortung',
    SCENARIOS: 'Szenario',
    SECURITYAWARENESS: 'Sicherheitsbewusstsein',
    TARGETTYPE: 'Zieltyp',
    THREATDIRECTION: 'Bedrohungsrichtung',
    ACTOR: 'Akteur',
    ACTION: 'Aktion',
    ACCESS: 'Zugang',
    MEANS: 'Mittel',
    TYPEOFENVIRONMENT: 'Umgebungstyp',
    TYPEOFOBJECT: 'Objekttyp',
    WEAPON: 'Waffe',
    WEATHERBEHAVIOUR: 'Wetterverhalten',
    WEATHERTYPE: 'Wetterbedingung',
    PI: 'Geschütztes Interesse (Ziel)',
    MEANSWEAPON: 'Mittel/Waffe',
    MISSIONCONTEXT: 'Missionskontext',
    ADVERSARY: 'Gegner',
    C2HEADQUARTERS: 'C2-HQ Standort',
    TARGET: 'Ziel',
    DELIBERATEACTION: 'Vorsätzliche Aktion',
    MEANS2: 'Angriffsmittel',
    MEANS3: 'Aktionsmittel',
    MEANS4: 'Zugangsmittel',
    ACCESS2: 'Zugangsmittel',
    MEANS2ACCESS: 'Mittel zum Zugang',
  },
  MODEL_NAMES: {
    0: 'Leeres Modell',
    1: 'Starterpaket',
  },
  MODEL_DESC: {
    0: 'Mit einer leeren morphologischen Box beginnen.',
    1: 'Zehn deutschsprachige Übungsboxen mit Beispielen, Ausschlüssen, Textvorlagen und LLM-Prompts.',
  },
  JSON_NOT_VALID: 'JSON-Modelldatei nicht gültig! Abbruch.',
  NO_NARRATIVE: 'In 100 Versuchen wurde kein Szenario generiert!',
  ALL_LOCKED_WARNING:
    'Alle Komponenten sind gesperrt — kein neues Szenario kann generiert werden. Löschen Sie zunächst das aktuelle Szenario.',
  SPEC_CATS:
    'Spezifizieren Sie zunächst einige Kategorien, wobei jede Kategorie einige Schlüsseltreiber enthält.',
  TRANSPOSE_BOX: {
    COLUMNS: 'Schlüsseltreiber als Spalten anzeigen',
    ROWS: 'Schlüsseltreiber als Zeilen anzeigen',
  },
  EXPORT2WORD: {
    TITLE: 'Nach Word exportieren',
    DESC: 'Welches Szenario möchten Sie exportieren?',
    CURRENT: 'Aktuelles',
    SELECTED: 'Ausgewählte',
    ALL: 'Alle',
    INCLUDE_BOX: 'Morphologischen Kasten einfügen (eine Tabelle pro Kategorie, ausgewählte Werte hervorgehoben)',
    INCLUDE_DECISIONS: 'Entscheidungsanalyse einbeziehen (Übersicht, Vergleich der Handlungsoptionen, Risikomatrix und Entscheidungsprotokoll)',
  },
  HIDE_INCONSISTENT: 'Inkonsistente Kombinationen ausblenden',
  GOAL: {
    TITLE: 'Ziel',
    DESC: 'ScenarioSpark ist eine Webanwendung, die zur systematischen Erstellung und Verwaltung einer Reihe von Szenarien für Risikomanagement-Aktivitäten verwendet werden kann.',
  },
  USAGE: {
    TITLE: 'Verwendung',
    DESC: 'ScenarioSpark unterstützt den Benutzer bei der Erstellung und Zusammenstellung einer repräsentativen Reihe von Szenarien, die in den verschiedenen Schritten des Risikomanagementprozesses verwendet werden können.',
  },
  SECURITY: {
    TITLE: 'Sicherheit',
    DESC: 'Alle verwendeten und eingegebenen Informationen werden ausschließlich lokal verarbeitet und gespeichert.',
  },
  SUMMARY:
    'Ein kostenloses Werkzeug, um Sie bei der Erstellung neuer Szenarien mithilfe eines morphologischen Kastens zu unterstützen. Zunächst definieren Sie die Aspekte, die in Ihrem Bereich von Interesse sind. Dann geben Sie Variationen für jeden Aspekt an. Und schließlich erstellen Sie entweder manuell neue Szenarien oder lassen sich durch die automatische Generierung möglicher Szenarien inspirieren.',
  SET_LANGUAGE: 'Sprache einstellen',
  SCENARIO_LOADED_MSG: 'Box geladen',
  COLLECTION_LOADED_MSG: 'Die Box-Sammlung wurde geladen',
  SCENARIO_NOT_LOADED_MSG:
    'Die Box wurde nicht geladen: Sie ist möglicherweise bereits in der Sammlung.',
  IMPORT_CONFLICT_TITLE: 'Box existiert bereits',
  IMPORT_CONFLICT_MSG:
    'Eine Box namens "{name}" ist bereits in deiner Sammlung. Was möchtest du tun?',
  IMPORT_OVERWRITE: 'Überschreiben',
  IMPORT_AS_COPY: 'Als Kopie hinzufügen',
  SCENARIO_CREATED_MSG: 'Box erstellt',
  COPY_TO_CLIPBOARD: 'Tabelle in Zwischenablage kopieren',
  GROUP: {
    SELECTED: 'Ausgewählte Szenarien',
    UNSELECTED: 'Nicht ausgewählte Szenarien',
  },
  MORE_ACTIONS: 'Weitere Aktionen',
  CLONE_NARRATIVE: 'Klonen',
  INCLUDE_DECISION_SUPPORT: 'Entscheidungsunterstützung aktivieren',
  IS_DECISION_CATEGORY: 'Für Entscheidungsunterstützung',
  DECISION_CATEGORY_HINT: "Faktoren in einer Entscheidungskategorie sind manuell: Sie werden nicht generiert, Sie wählen sie, nachdem Sie die Situation beschrieben haben. Entscheidungskategorien werden nur angezeigt, wenn die Entscheidungsunterstützung aktiviert ist.",
  DECISION_CATEGORIES_HIDDEN: "Entscheidungskategorien ({count}) sind ausgeblendet.",
  DECISION_CATEGORIES_OPEN_SETTINGS: "Einstellungen öffnen",
  DECISIONS: "Entscheidungen",
  DECISIONS_HINT: "Wählen Sie die Maßnahmen, die zur obigen Situation passen. Optionen, die der Situation widersprechen, sind ausgegraut.",
  EXCLUDED_BY: "ausgeschlossen durch {situation}",
  COURSES_OF_ACTION: "Handlungsoptionen",
  COURSE_OF_ACTION: "Handlungsoption",
  COA_ACTIVE: "aktiv",
  ADD_COA: "Hinzufügen",
  DUPLICATE_COA: "Duplizieren",
  RENAME_COA: "Handlungsoption umbenennen",
  DELETE_COA: "Handlungsoption löschen",
  COA_NAME: "Name der Handlungsoption",
  COA_NOTES: "Notizen zu dieser Handlungsoption",
  COA_HAS_CONFLICTS: "Enthält Maßnahmen, die der Situation widersprechen",
  COA_CONFLICT: "{value} widerspricht der Situation ({situation})",
  REFLECT_ON_DECISIONS: "LLM fragen: Entscheidungen reflektieren",
  COA_REFLECTION: "Reflexion zu dieser Handlungsoption",
  DECISION_PROMPT_COPIED: "Entscheidungs-Prompt kopiert. Fügen Sie ihn in den Chat Ihres KI-Assistenten ein und die Antwort in das Reflexionsfeld.",
  DECISION_REFLECTION_ERROR: "Die Reflexion konnte nicht erstellt oder kopiert werden. Versuchen Sie es erneut.",
  DECISION_REFLECTION_DISCARDED: "Die Reflexion wurde nicht gespeichert: Das Szenario oder die Handlungsoption hat sich während der Erstellung geändert.",
  NO_DECISION_CATEGORIES: "Diese Box hat keine Entscheidungskategorien. Markieren Sie in den Einstellungen eine Kategorie als „Für Entscheidungsunterstützung“, um hier Maßnahmen zu vergleichen.",
  DECISION_VIEW_OVERVIEW: "Übersicht",
  DECISION_VIEW_COA: "Handlungsoptionen vergleichen",
  DECISION_VIEW_ROBUSTNESS: "Robustheit",
  COMPARE_SCENARIO: "Zu vergleichendes Szenario",
  SHOW_DIFFERENCES_ONLY: "Nur Unterschiede anzeigen",
  NO_INCLUDED_NARRATIVES: "Es sind noch keine Szenarien für die Analyse ausgewählt. Wählen Sie Szenarien auf der Seite Szenario erstellen aus, um sie hier zu vergleichen.",
  NO_CURRENT_NARRATIVE: "Kein Szenario geöffnet. Öffnen oder speichern Sie zuerst ein Szenario auf der Seite Szenario erstellen.",
  NO_COAS: "Dieses Szenario hat noch keine Handlungsoptionen. Fügen Sie sie auf der Seite Szenario erstellen hinzu.",
  NO_COA_DIFFERENCES: "Alle Handlungsoptionen wählen dieselben Maßnahmen.",
  NO_DECISION_SELECTED: "keine",
  ROBUSTNESS_HINT: "Welche Maßnahmen tragen im aktuellen Szenario und in den zur Analyse ausgewählten Szenarien? Jede Spalte ist ein Szenario mit seiner aktiven Handlungsoption; eine in allen Szenarien gewählte Maßnahme ist ein sicherer erster Schritt, eine nur in einem Szenario gewählte hängt davon ab, wie sich die Lage entwickelt.",
  ROBUSTNESS_ONE_SCENARIO: "Die Robustheit vergleicht zwei oder mehr Szenarien. Speichern Sie auf der Seite {page} ein weiteres Szenario und wählen Sie es zur Analyse aus, um zu sehen, welche Maßnahmen in allen Szenarien tragen.",
  SCENARIO_CURRENT: "aktuell",
  ROBUSTNESS_MEASURE: "Maßnahme",
  ROBUSTNESS_CHOSEN: "Gewählt",
  ROBUSTNESS_EXCLUDED: "Durch die Lage ausgeschlossen",
  ROBUSTNESS_UNUSED: "Nicht verwendet",
  ROBUSTNESS_CHOSEN_IN: "Gewählt in",
  ROBUSTNESS_COUNT: "{count} von {total}",
  ROBUSTNESS_ROBUST: "Robust: in jedem Szenario gewählt",
  ROBUSTNESS_SPECIFIC: "Szenariospezifisch: nur in einem Szenario gewählt",
  SUGGESTED_WHY: "Warum dieser Vorschlag",
  SUGGESTED_HINT: "Je Faktor die Maßnahmen mit der höchsten risikogewichteten Anzahl über die aktiven Handlungsoptionen. Maßnahmen, die in jeder verglichenen Situation oder zusammen mit einer stärkeren Wahl unmöglich sind, werden übersprungen; unwahrscheinliche Kombinationen sind erlaubt, prüfen Sie diese also selbst.",
  SUGGESTED_PICK: "gewählt in {count} von {total} Szenarien, Gewicht {weight}",
  SUGGESTED_SKIPPED_EXCLUDED: "{value} übersprungen: in jeder verglichenen Situation unmöglich ({causes})",
  SUGGESTED_SKIPPED_CONFLICT: "{value} übersprungen: unmöglich zusammen mit {causes}",
  SUGGESTED_NONE: "Kein Vorschlag: kein Szenario hat eine Maßnahme gewählt",
  SUGGESTED_NONE_EXCLUDED: "Kein Vorschlag: jede gewählte Maßnahme ist in allen verglichenen Situationen unmöglich",
  SUGGESTED_NONE_CONFLICT: "Kein Vorschlag: jede gewählte Maßnahme ist zusammen mit einer stärkeren Wahl unmöglich",
  RESIDUAL_PROBABILITY: "Wahrscheinlichkeit nach dieser Handlungsoption",
  RESIDUAL_IMPACT: "Auswirkung nach dieser Handlungsoption",
  RESIDUAL_RISK: "Restrisiko",
  COA_RISK_HINT: "Optional: Schätzen Sie das Risiko, das bei Durchführung dieser Handlungsoption verbleibt. Es wird mit dem Risiko der Lage verglichen.",
  SITUATION_RISK_HINT: "Risiko der Lage, wenn nicht eingegriffen wird: die Wahrscheinlichkeit, dass sie eskaliert oder (weiteren) Schaden verursacht, und die Auswirkung, falls dies geschieht.",
  RISK_DOWN_FROM: "Gesunken von {before}",
  RISK_UP_FROM: "Gestiegen von {before}",
  RISK_SAME_AS: "Gleich wie die Lage ({before})",
  COA_RISK_SUMMARY: "Restrisiko: {after} (Situation: {before})",
  COA_RISK_SUMMARY_SHORT: "Restrisiko: {after}",
  RISK_BEFORE_AFTER: "Risiko: Situation → nach der Handlungsoption",
  RISK_TRANSITION: "{before} → {after}",
  RISK_CHANGE: { lower: "Geringeres Risiko", same: "Gleiches Risiko", higher: "Höheres Risiko" },
  RISK_NOT_SET: "nicht angegeben",
  DECISION_VIEW_RISK: "Risikomatrix",
  RISK_MATRIX_CAPTION: "Risikomatrix: Wahrscheinlichkeit (Zeilen) × Auswirkung (Spalten)",
  RISK_MATRIX_HINT: "Zahlen sind das aktuelle Szenario (1) und die zur Analyse ausgewählten Szenarien (Risiko der Situation); Buchstaben sind die Handlungsoptionen des gewählten Szenarios (Restrisiko).",
  RISK_MATRIX_MARKER: "Markierung",
  RISK_MATRIX_ITEM: "Szenario oder Handlungsoption",
  RISK_MATRIX_CELL: "Wahrscheinlichkeit {probability}, Auswirkung {impact}: Risiko {risk}",
  RISK_MATRIX_LEGEND: "Risikostufe",
  RISK_LEVEL_HINT: { 0: 'Akzeptabel; keine zusätzlichen Maßnahmen nötig.', 1: 'Akzeptabel; Lage beobachten.', 2: 'Risiko verringern, soweit vernünftigerweise möglich.', 3: 'Nicht akzeptabel; Maßnahmen mit Vorrang nötig.', 4: 'Nicht akzeptabel; sofort handeln.' },
  RISK_MATRIX_UNPLACED: "Nicht eingetragen (Wahrscheinlichkeit oder Auswirkung fehlt): {items}",
  RISK_MATRIX_EMPTY: "Geben Sie Wahrscheinlichkeit und Auswirkung der einbezogenen Szenarien an, um sie einzutragen.",
  CRITERIA_SCORING: "Bewertung nach Kriterien (optional)",
  CRITERIA_HINT: "Bewerten Sie jede Handlungsoption je Kriterium von 1 (schlecht) bis 5 (gut) und legen Sie fest, wie stark jedes Kriterium zählt (0 = ignorieren). Die gewichtete Punktzahl ist die Summe aus Gewicht × Bewertung.",
  CRITERIA: { effect: "Wirkung", speed: "Schnelligkeit", capacity: "Kapazität", safety: "Sicherheit der Einsatzkräfte", legality: "Rechtmäßigkeit", acceptance: "Öffentliche Akzeptanz" },
  CRITERIA_CRITERION: "Kriterium",
  CRITERIA_WEIGHT: "Gewicht",
  CRITERIA_WEIGHT_FOR: "Gewicht von {criterion}",
  CRITERIA_SCORE_FOR: "Bewertung der Handlungsoption {coa} für {criterion}",
  CRITERIA_TOTAL: "Gewichtete Punktzahl",
  CRITERIA_RANK: "Rang",
  CRITERIA_TOTAL_OF: "{total} von {max}",
  CRITERIA_MISSING: "{count} nicht bewertet",
  DECISION_EXPORT: "Nach Word exportieren",
  DECISION_EXPORT_TITLE: "Entscheidungsunterstützung",
  DECISION_EXPORT_DATE: "Exportiert am {date}",
  DECISION_LOG: "Entscheidungsprotokoll",
  DECISION_LOG_HINT: "Halten Sie getroffene Entscheidungen mit ihrer Begründung fest. Einträge bleiben erhalten, wenn ein Szenario oder eine Handlungsoption gelöscht wird.",
  DECISION_LOG_EMPTY: "Noch keine Entscheidungen erfasst.",
  RECORD_DECISION: "Entscheidung erfassen",
  EDIT_DECISION: "Entscheidung bearbeiten",
  DELETE_DECISION: "Entscheidung löschen",
  DECISION_LOG_DATE: "Datum und Uhrzeit",
  DECISION_LOG_SCENARIO: "Szenario",
  DECISION_LOG_DECISION: "Entscheidung",
  DECISION_LOG_RATIONALE: "Begründung",
  DECISION_LOG_AUTHOR: "Entschieden von",
  DECISION_LOG_REMOVED: "gelöscht",
  DECISION_LOG_NO_SCENARIO: "Kein bestimmtes Szenario",
  DECISION_LOG_NO_COA: "Keine bestimmte Handlungsoption",
  DECISION_LOG_EDITED: "bearbeitet am {date}",
  CRITERIA_NOT_SCORED: "nicht bewertet",
  DECISION_PROMPT_TITLE: "Entscheidungsunterstützung aktivieren?",
  DECISION_PROMPT_MSG: "Diese Box enthält Entscheidungskategorien, etwa Maßnahmen, die Sie nach der Beschreibung der Situation wählen. Aktivieren Sie die Entscheidungsunterstützung, um sie zu wählen und zu vergleichen.",
  DECISION_PROMPT_LATER_NOTE: "Sie können dies später in den Einstellungen ändern.",
  DECISION_PROMPT_ENABLE: "Aktivieren",
  DECISION_PROMPT_NOT_NOW: "Nicht jetzt",
  PROBABILITY: 'Eintrittswahrscheinlichkeit',
  IMPACT: 'Auswirkung',
  RISK: 'Risiko',
  RISK_PLACEHOLDER: 'Wahrscheinlichkeit x Auswirkung',
  PROB5: {
    0: 'Sehr niedrig',
    1: 'Niedrig',
    2: 'Mittel',
    3: 'Hoch',
    4: 'Sehr hoch',
  },
  IMP5: {
    0: 'Sehr niedrig',
    1: 'Niedrig',
    2: 'Mittel',
    3: 'Hoch',
    4: 'Sehr hoch',
  },
  RISK5: {
    0: 'Sehr niedrig',
    1: 'Niedrig',
    2: 'Mittel',
    3: 'Hoch',
    4: 'Sehr hoch',
  },
  SUGGESTED_APPROACH: {
    TITLE: 'Vorgeschlagener Ansatz',
    DESC: 'Der vorgeschlagene Ansatz ist eine (risiko-)gewichtete Kombination der ausgewählten Gegenmaßnahmen.',
  },
  TEMPLATE: {
    TITLE: 'Vorlagenzeichenfolge für Fließtext',
    DESC: 'Schreiben Sie einen Absatz, in dem XXX durch den Wert für Schlüsselfaktor 1 usw. ersetzt wird. Leere Zeilen werden in Absätze umgewandelt.',
  },
  SELECT_PERSONA: 'Relevante Persona für Szenario auswählen',
  SELECT_PERSONA_HELP: 'Halten Sie fest, wie jede ausgewählte Persona ein gespeichertes Szenario wahrnimmt, auf Maßnahmen reagiert und informiert oder einbezogen werden sollte.',
  PERSONA_IMPRESSION: 'Feedback der Persona',
  COPY_PERSONA_PROMPT: 'Feedback-Prompt kopieren',
  COPY_PERSONA_PROMPT_SHORT: 'Kopieren',
  COPY_PERSONA_PROMPT_FOR: 'Feedback-Prompt für {persona} kopieren',
  GENERATE_PERSONA_FEEDBACK: 'Feedback generieren',
  GENERATE_PERSONA_FEEDBACK_SHORT: 'Generieren',
  GENERATE_PERSONA_FEEDBACK_FOR: 'Feedback für {persona} generieren',
  PERSONA_PROMPT_COPIED: "Feedback-Prompt kopiert. Fügen Sie ihn in den Chat Ihres KI-Assistenten ein und die Antwort in dieses Feld.",
  PERSONA_PASTE_HINT: 'Fügen Sie die LLM-Antwort direkt in das Feld oben ein; sie wird automatisch gespeichert.',
  PERSONA_FEEDBACK_ERROR: 'Feedback konnte nicht generiert oder kopiert werden. Versuchen Sie es erneut.',
  PERSONA: {
    1: 'Persona',
    n: 'Personas',
  },
  IMAGE: 'Bild',
  SAVE: 'Speichern',
  EDIT: 'Bearbeiten',
  MARKDOWN_FIELD_EMPTY: "Klicken, um Text hinzuzufügen",
  LLM: 'LLM',
  SERVICE: 'Dienst',
  PROVIDER: 'Anbieter',
  SYSTEM_PROMPT: 'System-Prompt',
  USER_PROMPT: 'Narrativ-Prompt',
  EFFECT_PROMPT: 'Auswirkungs-Prompt',
  PERSONA_PROMPT: 'Persona-Prompt',
  COMMUNICATIONS_PROMPT: 'Kommunikations-Prompt',
  TEMPERATURE: {
    BTN: 'Temperatur',
    DESC: 'Wie kreativ soll das LLM sein (max = 1)?',
  },
  API_KEY: 'API-Schlüssel',
  URL: 'URL',
  ASK_LLM: 'LLM fragen',
  INCLUDE_LLM: 'In LLM einbeziehen',
  OLLAMA_URL:
    'Hostname (und optional Port über einen [Proxy](https://github.com/erikvullings/proxy))',
  ADV_EDIT: 'Code-Editor',
  TOGGLE: { SHOW: 'Tabelle anzeigen', HIDE: 'Tabelle ausblenden' },
  AUTO_CREATE: {
    BTN: 'Automatisch erstellen',
    COUNT: 'LLM automatische Erstellungsanzahl',
    COUNT_DESC: 'Wie viele Szenarien möchten Sie auf einmal generieren?',
  },
  AUTO_CREATE_MSG: {
    1: `1 Szenario automatisch erstellen`,
    n: '{n} Szenarien automatisch erstellen',
  },
  COPY_BOX: {
    LABEL: 'Kasten kopieren',
    TITLE: 'Tabelle in Zwischenablage kopieren',
    TOAST: 'Morphologischer Kasten in Zwischenablage kopiert.',
  },
  PROMPT_TYPE: {
    PROMPTS: 'Prompts',
    LABEL: 'Prompt-Typ',
    NARRATIVE: 'Narrativ-Prompt',
    EFFECT: 'Auswirkungs-Prompt',
    PERSONA: 'Persona-Prompt',
    COM: 'Kommunikations-Prompt',
    DECISION: "Prompt zur Reflexion über Entscheidungen",
  },
  LLM_DEFAULT_NARRATIVE_PROMPT:
    'Verwenden Sie die folgenden Elemente, um ein realistisches Szenario zu definieren.',
  LLM_INCLUDED_CATEGORIES: 'Einbezogene Kategorien',
  LLM_PROMPT_TEXT: 'Prompt',
  LLM_CATEGORY_REQUIRED: 'Wählen Sie mindestens eine Kategorie für diesen Prompt aus.',
  LLM_DEFAULT_PERSONA_PROMPT:
    'Beschreiben Sie, wie die Zielpersona diese Situation wahrnimmt, einschließlich vorgeschlagener Maßnahmen und gegebenenfalls wie sie informiert oder einbezogen werden sollte. Stützen Sie sich auf das Szenario und die Persona-Beschreibungen; erfinden Sie keine Details. Geben Sie nur das Feedback der Zielpersona zurück, direkt zum Einfügen in ihr Feedbackfeld. Keine Überschrift, kein Persona-Name und keine Codeblöcke.',
  LLM_PERSONA_CONTEXT: 'Ausgewählte Personas und Beschreibungen:\n{personas}',
  LLM_PERSONA_TARGET: 'Schreiben Sie Feedback nur für: {persona}',
  LLM_SCENARIO_TEXT: 'Szenariobeschreibung:\n{narrative}',
  LLM_SITUATION: "Lage (verwenden Sie diese Elemente, um den Vorfall zu beschreiben):",
  LLM_SUGGESTED_ACTIONS: "Vorgeschlagene Maßnahmen (zu beschreiben und zu bewerten):",
  LLM_NO_MEASURES_SELECTED: "Es wurden keine Maßnahmen ausgewählt: Beschreiben Sie nur den Vorfall und erfinden Sie keine Maßnahmen oder Lösung.",
  LLM_DEFAULT_DECISION_PROMPT: "Sie sind ein erfahrener Berater für Krisenmanagement. Bewerten Sie die folgende Handlungsoption für die gegebene Lage. Bleiben Sie bei der gegebenen Lage und Szenariobeschreibung; erfinden Sie keine Fakten. Fassen Sie sich kurz: höchstens 250 Wörter, in Markdown, mit genau diesen Teilen: **Urteil** (2–3 Sätze zu Eignung, Zeitpunkt und Reihenfolge), **Stärken** (2 Aufzählungspunkte), **Risiken und Lücken** (2–3 Aufzählungspunkte, einschließlich dessen, was fehlt) und **Verbesserung** (1 konkrete Empfehlung). Fügen Sie keinen Titel und keine Codeblöcke hinzu.",
  LLM_DECISION_SITUATION: "Situation (der Vorfall, auf den die Entscheidungen reagieren):",
  LLM_COA_DECISIONS: "Handlungsoption {coa}: zu bewertende Entscheidungen:",
  LLM_COA_NO_DECISIONS: "Für Handlungsoption {coa} sind noch keine Entscheidungen ausgewählt: Geben Sie an, welche Entscheidungen nötig sind.",
  LLM_OTHER_COAS: "Weitere erwogene Handlungsoptionen (nur zum Vergleich; nicht bewerten):",
  LLM_COMBINED_INTRO: "Erledigen Sie alle folgenden Aufgaben für ein Szenario. Antworten Sie mit einem einzigen JSON-Objekt in einem ```json-Codeblock und sonst nichts.",
  LLM_COMBINED_TASK_NARRATIVE: "Aufgabe: Szenariobeschreibung schreiben",
  LLM_COMBINED_CURRENT_NARRATIVE: "Aktuelle Szenariobeschreibung (verbessern Sie sie und behalten Sie, was noch passt):\n{narrative}",
  LLM_COMBINED_TASK_DECISIONS: "Aufgabe: jede Handlungsoption bewerten",
  LLM_COMBINED_TASK_PERSONAS: "Aufgabe: Feedback je Persona schreiben, basierend auf Ihrer Szenariobeschreibung",
  LLM_COMBINED_OUTPUT: "Ausgabeformat (diese Regeln haben Vorrang vor früheren Formatierungsanweisungen): Füllen Sie die JSON-Vorlage unten aus. Lassen Sie jede id unverändert, setzen Sie einen kurzen, aussagekräftigen Titel in \"title\", schreiben Sie die Texte in Markdown, verwenden Sie \\n für Zeilenumbrüche in Strings und fügen Sie keine weiteren Felder oder Text außerhalb des Codeblocks hinzu.",
  COMBINED_PROMPT: "Alles-in-einem-Prompt",
  COMBINED_PROMPT_TITLE: "Ein Prompt für Szenariobeschreibung, Bewertung der Handlungsoptionen und Persona-Feedback; fügen Sie die JSON-Antwort wieder ein",
  COMBINED_TITLE: "Alles-in-einem KI-Prompt",
  COMBINED_HINT: "Der Prompt ist in Ihrer Zwischenablage. Fügen Sie ihn in Ihren KI-Assistenten (z. B. Copilot) ein und fügen Sie dessen JSON-Antwort unten ein. Dieses Fenster bleibt währenddessen geöffnet.",
  COMBINED_COPY: "Prompt kopieren",
  COMBINED_COPIED: "Prompt kopiert. Fügen Sie die JSON-Antwort unten ein.",
  COMBINED_PASTE: "KI-Antwort (JSON)",
  COMBINED_PARSE_ERROR: "Kein gültiges JSON in dieser Antwort gefunden. Bitten Sie die KI, nur den JSON-Codeblock zurückzugeben.",
  COMBINED_APPLY: "Übernehmen",
  COMBINED_APPLIED: "Szenario mit der KI-Antwort aktualisiert.",
  COMBINED_UNMATCHED: "Nicht erkannt, übersprungen: {names}",
  COMBINED_REPLACES: "ersetzt vorhandenen Text",
  COMBINED_FIELD_TITLE: "Titel",
  COMBINED_FIELD_NARRATIVE: "Szenariobeschreibung",
  COMBINED_HINT_API: "Erzeugen Sie die Antwort mit dem eingestellten KI-Dienst oder kopieren Sie den Prompt und fügen Sie die JSON-Antwort unten ein. Prüfen Sie das Ergebnis vor dem Übernehmen.",
  COMBINED_GENERATE: "Erzeugen",
  COMBINED_GENERATE_ERROR: "Der KI-Dienst hat keine Antwort geliefert. Prüfen Sie die LLM-Einstellungen oder kopieren Sie den Prompt.",
  LLM_FIELD_PROMPTS: "Prompt pro Feld",
  LLM_FIELD_PROMPTS_DESC: "Der All-in-one-Prompt bleibt verfügbar. Zeigen Sie zusätzlich eine Prompt-Schaltfläche bei der Szenariobeschreibung, jeder Bewertung und jeder Persona, um nur diesen Teil (neu) zu erzeugen.",
  AI_NARRATIVE: "LLM fragen: Szenariobeschreibung schreiben",
  COPY_NARRATIVE_PROMPT: "Szenario-Prompt kopieren",
  NARRATIVE_PASTE_HINT: "Kopieren Sie den Prompt, fragen Sie Ihren KI-Assistenten und fügen Sie die Antwort in die Szenariobeschreibung ein.",
  NARRATIVE_GENERATE_ERROR: "Die Szenariobeschreibung konnte nicht erzeugt werden. Prüfen Sie die LLM-Einstellungen.",
  RESPONSE_INSTRUCTIONS:
    'Beginnen Sie Ihre Antwort mit einem kurzen, beschreibenden Titel in einer eigenen Zeile, dann einer Leerzeile, dann dem Hauptinhalt.',
  WIZARD_STEP1_TITLE: 'Box-Informationen',
  WIZARD_STEP1_SUBTITLE: 'Benennen und beschreiben Sie Ihre Box',
  WIZARD_STEP2_TITLE: 'Schlüsseltreiber',
  WIZARD_STEP2_SUBTITLE:
    'Definieren Sie die morphologische Kategorie und Schlüsseltreiber',
  WIZARD_STEP3_TITLE: 'Treiberoptionen',
  WIZARD_STEP3_SUBTITLE: 'Optional Optionen für jeden Treiber hinzufügen',
  WIZARD_CATEGORY_INFO: 'Kategoriedetails',
  WIZARD_COMPONENTS_INFO: 'Schlüsseltreiber (Dimensionen)',
  WIZARD_VALUES_INFO: 'Wählen Sie einen Treiber aus, um Optionen hinzuzufügen:',
  WIZARD_NO_COMPONENTS:
    'Noch keine Treiber definiert. Gehen Sie zurück zu Schritt 2.',
  WIZARD_VALUES_FOR_COMPONENT: 'Optionen für {component}',
  WIZARD_DEFAULT_CATEGORY_NAME: 'Initiale Morphologische Box',
  WIZARD_NEXT: 'Weiter',
  WIZARD_PREVIOUS: 'Zurück',
  WIZARD_COMPLETE: 'Box erstellen',
  WIZARD_SKIP: 'Überspringen',
  LLM_WIZARD_TITLE: 'Box mit KI erstellen',
  LLM_WIZARD_STEP1_TITLE: 'Anforderungen definieren',
  LLM_WIZARD_STEP1_SUBTITLE: 'Spezifizieren Sie, was Sie generieren möchten',
  LLM_WIZARD_STEP1_DESC:
    'Füllen Sie die Details unten aus, um Ihre morphologische Kasten-Generierung anzupassen:',
  LLM_WIZARD_STEP2_TITLE: 'Prompt überprüfen',
  LLM_WIZARD_STEP2_SUBTITLE:
    'Überprüfen und bearbeiten Sie den vollständigen Prompt',
  LLM_WIZARD_STEP2_DESC:
    'Überprüfen Sie den kombinierten Prompt unten. Sie können ihn bei Bedarf bearbeiten:',
  LLM_WIZARD_STEP3_TITLE: 'LLM konfigurieren',
  LLM_WIZARD_STEP3_SUBTITLE: 'LLM-Dienst und Einstellungen auswählen',
  LLM_WIZARD_STEP3_DESC:
    'Konfigurieren Sie, wie Sie den morphologischen Kasten generieren möchten:',
  LLM_WIZARD_STEP4_TITLE: 'Box generieren',
  LLM_WIZARD_STEP4_SUBTITLE: 'Generieren oder fügen Sie das Ergebnis ein',
  LLM_WIZARD_STEP4_CLIPBOARD_DESC:
    'Der Prompt ist bereit. Kopieren Sie ihn und verwenden Sie ein externes LLM, um den morphologischen Kasten zu generieren:',
  LLM_PURPOSE: 'Zweck',
  LLM_PURPOSE_HELP:
    'Was möchten Sie erkunden oder entwerfen? Z.B. "Krisenmanagement-Szenarien für nationale Notfallplanung"',
  LLM_DOMAIN: 'Bereich',
  LLM_DOMAIN_HELP:
    'Geben Sie das Fachgebiet oder den Kontext an, z.B. "Katastrophenschutz", "Cybersicherheit", "militärische Operationen"',
  LLM_OUTPUT_TYPE: 'Ausgabetyp',
  LLM_OUTPUT_TYPE_HELP:
    'Ein morphologischer Kasten, mehrere Kästen, szenariofokussiert, maßnahmenfokussiert oder beides?',
  LLM_CONSTRAINTS: 'Einschränkungen oder Schwerpunktbereiche',
  LLM_CONSTRAINTS_HELP:
    'Z.B. "Soziopolitische, ökologische und technologische Faktoren einbeziehen"',
  LLM_DETAIL_DEPTH: 'Detailtiefe',
  LLM_DETAIL_DEPTH_HELP:
    'Z.B. "6-7 detaillierte Optionen pro Faktor einbeziehen, jeweils mit einer Ein-Satz-Definition"',
  LLM_LANGUAGE: 'Ausgabesprache',
  LLM_LANGUAGE_HELP:
    'Die Sprache für den generierten Inhalt, z.B. "Englisch", "Deutsch"',
  LLM_FULL_PROMPT: 'Vollständiger Prompt',
  LLM_ENDPOINT: 'Generierungsmethode',
  LLM_CLIPBOARD: 'In Zwischenablage kopieren (externes LLM verwenden)',
  LLM_OLLAMA: 'Mit Ollama generieren',
  LLM_OPENAI: 'Mit OpenAI generieren',
  LLM_OLLAMA_URL_HELP: 'Ollama API URL, z.B. http://localhost:11434/api/chat',
  LLM_OPENAI_URL_HELP: 'OpenAI API URL (leer lassen für Standard)',
  LLM_OLLAMA_MODEL_HELP: 'Modellname, z.B. gemma2, llama3, qwen2.5',
  LLM_OPENAI_MODEL_HELP: 'Modellname, z.B. gpt-4o-mini, gpt-4o',
  LLM_COPY_PROMPT: 'Prompt in Zwischenablage kopieren',
  TEMPLATE_PROMPT_COPIED: 'Vorlagenprompt in Zwischenablage kopiert',
  TEMPLATE_PROMPT_COPY: 'LLM-Prompt in die Zwischenablage kopieren',
  LLM_PROMPT_COPIED: 'Prompt in Zwischenablage kopiert!',
  LLM_PASTE_OUTPUT: 'Fügen Sie die LLM-Ausgabe unten ein:',
  LLM_GENERATE: 'Mit LLM generieren',
  LLM_GENERATING: 'Generierung mit LLM läuft...',
  LLM_ERROR: 'Fehler beim Generieren',
  INCLUDE_MAP_SUPPORT: 'Kartenunterstützung aktivieren',
  SETTINGS_GENERAL: "Allgemein",
  SETTINGS_OPTIONS: "Optionen",
  SETTINGS_NARRATIVE: "Erzählung",
  SETTINGS_MAP: "Karte",
  SETTINGS_STRUCTURE: "Aufbau der Box",
  HIDE_INCONSISTENT_HINT: "Beim Erstellen eines Szenarios Optionen ausblenden, die mit Ihrer Auswahl unmöglich sind, statt sie nur zu markieren.",
  INCLUDE_MAP_SUPPORT_HINT: "Eine Karte beim Definieren der Box sowie beim Erstellen und Anzeigen von Szenarien zeigen, um Faktoren an einem Ort zu platzieren.",
  INCLUDE_DECISION_SUPPORT_HINT: "Maßnahmenkategorien, Handlungsoptionen und die Entscheidungsseite anzeigen.",
  MAP_CONFIG: 'Kartenkonfiguration',
  MAP_UNITS: 'Karteneinheiten',
  METRIC: 'Metrisch',
  IMPERIAL: 'Imperial',
  OSM_AMENITIES: 'OSM-Einrichtungen',
  TOGGLE_MAP: 'Karte anzeigen/verbergen',
  ZOOM_LEVEL: 'Zoomstufe',
  CIRCLE: 'Kreis',
  ELLIPSE: 'Ellipse',
  OSM_QUERY: 'OSM-Abfrage',
  RADIUS: 'Radius (m)',
  RADII: 'Radien (kommagetrennt, in Metern)',
  MAJOR_AXIS: 'Große Halbachse (m)',
  MINOR_AXIS: 'Kleine Halbachse (m)',
  ORIENTATION: 'Ausrichtung',
  ORIENTATION_DESC: 'Winkel in Grad (0 = Nord) oder Referenz-ID',

  LLM_GENERATED_MARKDOWN: 'Generiertes Markdown',

  IMPORT_FROM_SPREADSHEET: 'Aus Tabelle einfügen',
  IMPORT_PASTE_DATA: 'Tabellendaten einfügen',
  IMPORT_PLACEHOLDER:
    'Hier tabulatorgetrennte Daten aus Excel/Google Sheets einfügen...\n\nErste Zeile = Schlüssel-Treiber-Namen, jede Spalte = Optionen für diesen Treiber.',
  IMPORT_PARSE: 'Parsern & Importieren',
  IMPORT_NO_DATA: 'Keine Tabellendaten erkannt. Tabelle einfügen und erneut versuchen.',
  IMPORT_NO_DRIVERS:
    'Keine Schlüssel-Treiber erkannt. Überprüfen Sie die Einfügung.',
  IMPORT_NEEDS_TWO_COLUMNS:
    'Import benötigt mindestens 2 Spalten (Schlüssel-Treiber-Namen und Optionen).',
  CLOSE_MESSAGE: 'Meldung schließen',
  SEARCH_SCENARIO_TYPE: 'Szenariotypen suchen…',
  NO_SCENARIO_TYPE_FOUND: 'Keine Szenariotypen gefunden',
  COVERAGE_MENU: "Abdeckende Menge erzeugen…",
  COVERAGE_TITLE: "Szenarien erzeugen, die die Box abdecken",
  COVERAGE_DESC: "Erstellt unterschiedliche Szenarien, in denen jede Option ungefähr gleich oft vorkommt, statt sie zufällig zu wählen. Fixierte Optionen bleiben erhalten, unmögliche Kombinationen werden nie verwendet und unwahrscheinliche vermieden. Bereits vorhandene aufgenommene Szenarien zählen zur Balance.",
  COVERAGE_COUNT: "Anzahl der Szenarien",
  COVERAGE_BATCH_NAME: "Name der Serie (Präfix der Szenarionamen)",
  COVERAGE_BATCH_DEFAULT: "Serie",
  COVERAGE_PAIRS: "Auch Kombinationen von Optionen verteilen (paarweise)",
  COVERAGE_START: "Erzeugen",
  COVERAGE_STOP: "Stoppen",
  COVERAGE_PROGRESS: "{done} von {total} Szenarien",
  COVERAGE_DONE: "{count} Szenarien zu „{batch}“ hinzugefügt",
  COVERAGE_EXHAUSTED: "Es konnten nur {count} neue, unterschiedliche und konsistente Szenarien erstellt werden.",
  DELETE_BATCH_MENU: "Erzeugte Serie löschen…",
  DELETE_BATCH_TITLE: "Eine Serie erzeugter Szenarien löschen",
  DELETE_BATCH_SELECT: "Serie",
  DELETE_BATCH_KEEP_TEXT: "Szenarien behalten, die bereits eine Erzählung haben",
  DELETE_BATCH_DONE: "{count} Szenarien gelöscht",
  SHOW_GENERATED: "{count} erzeugte Szenarien ohne Erzählung anzeigen",
};
